import Vue from 'vue';

export default Vue.component('error-modal', {
  template: require('./template.html'),
  name: 'error-modal',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/error-modal/index.js